import { render, staticRenderFns } from "./Detailsaee10.vue?vue&type=template&id=1d85f904&"
import script from "./Detailsaee10.vue?vue&type=script&lang=js&"
export * from "./Detailsaee10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports